const statePropertyWaitingList = {
  selectedPropertyWaitingList: '',
  propertyList: [],
  isLoading: false,
  isLoadingLoadMore: false,
  limitPerPage: 10,
  nextPageUrl: null,
};

const stateTenantWaitingList = {
  tenantList: [],
  totalTenantWaitingList: 0,
  isLoadingTenantWaitingList: false,
  isLoadingLoadMoreTenantWaitingList: false,
  limitPerPageTenantWaitingList: 10,
  nextPageUrlTenantWaitingList: null,
  totalHiddenWaitingList: 0,
};

export const state = () => ({
  ...statePropertyWaitingList,
  ...stateTenantWaitingList,
});

const mutationsPropertyWaitingList = {
  setSelectedProperty(state, payload) {
    state.selectedPropertyWaitingList = payload;
  },
  setPropertyList(state, payload) {
    state.propertyList = payload;
  },
  appendPropertyList(state, payload) {
    state.propertyList = [...state.propertyList, ...payload];
  },
  setNextPageUrl(state, payload) {
    state.nextPageUrl = payload;
  },
  setLoadingPropertyWaitingList(state, { fetchNextData, isShow }) {
    if (!fetchNextData) {
      state.isLoading = isShow;
    } else {
      state.isLoadingLoadMore = isShow;
    }
  },
};

const mutationsTenantWaitingList = {
  setTenantWaitingList(state, payload) {
    state.tenantList = payload;
  },
  appendTenantWaitingList(state, payload) {
    state.tenantList = [...state.tenantList, ...payload];
  },
  setNextPageUrlTenantWaitingList(state, payload) {
    state.nextPageUrlTenantWaitingList = payload;
  },
  setLoadingTenantWaitingList(state, { fetchNextData, isShow }) {
    if (!fetchNextData) {
      state.isLoadingTenantWaitingList = isShow;
    } else {
      state.isLoadingLoadMoreTenantWaitingList = isShow;
    }
  },
  setTotalTenantWaitingList(state, payload) {
    state.totalTenantWaitingList = payload;
  },
  setTotalHiddenWaitingList(state, payload) {
    state.totalHiddenWaitingList = payload;
  },
};

export const mutations = {
  ...mutationsPropertyWaitingList,
  ...mutationsTenantWaitingList,
};

export const actions = {
  async fetchPropertyWaitingList({ commit, state }, fetchNextData = false) {
    commit('setLoadingPropertyWaitingList', {
      fetchNextData,
      isShow: true,
    });

    try {
      const options = {
        for: 'waiting_list',
        per_page: state.limitPerPage,
      };

      const response = !fetchNextData
        ? await this.$api.getRoomType(options)
        : await this.$axios.get(state.nextPageUrl);

      if (response) {
        const { room_types: roomTypes, meta } = response.data || {};

        if (fetchNextData) {
          commit('appendPropertyList', roomTypes);
        } else {
          commit('setPropertyList', roomTypes);
        }

        commit('setNextPageUrl', meta.next_page_url || null);
      }
    } catch (error) {
      this.$error.report(error);
    } finally {
      commit('setLoadingPropertyWaitingList', {
        fetchNextData,
        isShow: false,
      });
    }
  },

  async fetchTenantWaitingList({ commit, state }, fetchNextData = false) {
    commit('setLoadingTenantWaitingList', { fetchNextData, isShow: true });

    try {
      const options = {
        per_page: state.limitPerPageTenantWaitingList,
      };

      if (state.selectedPropertyWaitingList) {
        options.room_type_id = state.selectedPropertyWaitingList.id;
      }

      const response = !fetchNextData
        ? await this.$api.getTenantWaitingList(options)
        : await this.$axios.get(state.nextPageUrlTenantWaitingList);

      if (response) {
        const { waiting_lists: waitingLists, total_hidden: totalHidden, meta } =
          response.data || {};

        if (fetchNextData) {
          commit('appendTenantWaitingList', waitingLists);
        } else {
          commit('setTenantWaitingList', waitingLists);
        }

        commit('setNextPageUrlTenantWaitingList', meta.next_page_url || null);
        commit('setTotalTenantWaitingList', meta.total || 0);
        commit('setTotalHiddenWaitingList', totalHidden || 0);
      }
    } catch (error) {
      this.$error.report(error);
    } finally {
      commit('setLoadingTenantWaitingList', {
        fetchNextData,
        isShow: false,
      });
    }
  },
};
